module.exports = __webpack_public_path__ + "static/assets/e07c2545a026e36098dcc36a101b4716.svg";